const careers = document.querySelector('.js-careers');
const depts = document.querySelector('.js-depts');
const types = document.querySelector('.js-types');
const locations = document.querySelector('.js-locations');
const apply = document.querySelector('.js-apply');
var applyPage = document.querySelector('.job-apply');
var applyContainer = document.querySelector('.js-job-apply');
const jobAdvertPage = document.querySelector('.js-job-advert');
const heroHeading = document.querySelector('.image-hero__heading');
const herobtn = document.querySelector('.image-hero__link');
const hereoSubtext = document.querySelector('.image-hero__subheading');
const errorText = document.querySelector('.js-apply-error-text');
const broadbeanId = document.querySelector('[data-broadbean-id]');
const jobapplycv = document.querySelector('.job-apply__cv');
const fileLabel = document.querySelector('.js-file-label');
const errorBox = document.querySelector('.js-error-text');
const careerApplySuccessDiv = document.querySelector('.js-job-apply-success');
const careerApplyFormDiv = document.querySelector('.js-job-apply-form');
const loading = document.querySelector('.js-loading');
const consentRequired = document.querySelector('.js-consent-required');
var recruitmentEmail = document.querySelector('[name="recruiterEmail"]');

window.neptune.careers = {
  jobApplyErrors: [],
  currentJob: {},

  attachFile: function (isPageLoad = false) {
    var uploadFields = document.querySelectorAll('.js-file-upload');
    var container = document.querySelector(`.js-attach-file-${uploadFields.length + 1}`);

    var fileuploadLabels = document.querySelector('.js-file-labels');
    var html = `<div class="file-upload-dynamic"><label class="bttn bttn--outline bttn-max-width " for="cvUpload_${uploadFields.length + 1}">
          Attach a file
        </label><input
    class="js-file-upload hide"
          onchange="window.neptune.careers.filechange(this)"
          onkeyup="this.classList.remove('invalid')"
          type="file"
        
          id="cvUpload_${uploadFields.length + 1}"
          name="cvUpload_${uploadFields.length + 1}"
          accept=".doc,.docx,.pdf, .rtf"
          required
        ><span class="js-file-input file-input-label"></span></div>`;

    container.innerHTML += html;
  },
  filters: function (element) {
    document.querySelectorAll('.js-career-listing-item').forEach(e => {
      var isMatch = [];

      if (e.dataset.type == types.value || types.value == '0') {
        isMatch.push(1);
      }

      if (e.dataset.location == locations.value || locations.value == '0') {
        isMatch.push(1);
      }

      if (e.dataset.department == depts.value || depts.value == '0') {
        isMatch.push(1);
      }

      if (isMatch.length == 3) {
        e.classList.remove('hide');
      } else {
        e.classList.add('hide');
      }
    });
  },
  getId: function () {
    var id = 'n/a';
    if (broadbeanId != null) {
      return broadbeanId.dataset.broadbeanId;
    }
    if (window.location.href.indexOf('id=') != -1) {
      return new URLSearchParams(window.location.search).get('id');
    }

    return id;
  },
  jobAdvertInit: function () {
    if (window.neptune.careers.getId() == 'n/a') {
      applyContainer.setAttribute('style', 'display:none');
    }

    fetch(
      window.neptune.getAzureFunctionEnv() +
        '/api/JobListGetAsync?useCache=false&version=' +
        Math.random().toString().split('.')[1],
    ).then(r => {
      console.log('JobListGetAsync: cache build successful');
    });

    fetch(
      window.neptune.getAzureFunctionEnv() +
        '/api/JobListGetAsync?broadbeanId=' +
        window.neptune.careers.getId(),
    )
      .then(e => e.json())
      .then(r => {
        var model = r.Careers[0];
        window.neptune.careers.currentJob = model;

        if (heroHeading != null) {
          heroHeading.innerHTML = model.Name;
        }
        if (hereoSubtext != null) {
          hereoSubtext.innerHTML = model.Location.Name;
        }

        if (herobtn != null) {
          herobtn.href += '?id=' + window.neptune.careers.getId();
        }

        if (broadbeanId != null && broadbeanId.dataset.jobHide.toLowerCase() == 'true') {
          herobtn.classList.toggle('hide');
        }
      });
  },
  jobApplyPost: function () {
    this.jobApplyErrors = [];
    this.consentNotSelected = [];
    const formData = new FormData();
    document.querySelectorAll('.js-job-apply input[name]').forEach(e => {
      var value = e.value;
      if (
        ((e.type == 'text' && e.getAttribute('name').toLowerCase() != 'currentsalary') ||
          e.type == 'email') &&
        e.value.length == 0
      ) {
        e.classList.add('invalid');
        this.jobApplyErrors.push(e);
        return;
      }

      if (e.type == 'checkbox') {
        value = e.value.toLowerCase() == 'on';
      }

      if (e.type == 'file') {
        value = e.files[0];
      }

      if (e.type == 'radio') {
        if (e.checked == false) {
          this.consentNotSelected.push(e);
        }
      }

      console.log(e.getAttribute('name'), value);
      formData.append(e.getAttribute('name'), value);
    });

    var files = [];
    document.querySelectorAll('.js-file-upload').forEach(e => {
      if (e.files[0] != null) {
        files.push(e.files[0]);
      }
    });

    if (files.length == 0) {
      this.jobApplyErrors.push(document.querySelector('.js-attach-file-1'));
    }

    if (window.location.href.indexOf('email_address=') == -1) {
      if (
        applyPage.dataset.recruiterEmail == null ||
        applyPage.dataset.recruiterEmail.length == 0
      ) {
        formData.append('recruiterEmail', window.neptune.careers.currentJob.RecruiterEmailAddress);
      } else {
        formData.append('recruiterEmail', applyPage.dataset.recruiterEmail);
      }
    } else {
      const emailAddress = new URLSearchParams(window.location.search).get('email_address');
      formData.append('recruiterEmail', emailAddress);
    }

    formData.append('broadbeanId', this.getId());

    if (this.consentNotSelected.length == 2) {
      consentRequired.classList.add('invalid');
      this.consentNotSelected[0].scrollIntoView({ behavior: 'smooth' });
      return;
    }

    if (this.jobApplyErrors.length > 0) {
      this.jobApplyErrors[0].scrollIntoView({ behavior: 'smooth' });
      return;
    }

    formData.append('giveConsent', document.querySelector('[name="giveConsent"]:checked').value);
    formData.append('coverLetter', document.querySelector('.js-cover-letter').value);
    console.log('email would go to:', window.neptune.careers.currentJob.RecruiterEmailAddress);

    loading.classList.add('hide');
    try {
      fetch(window.neptune.getAzureFunctionEnv() + `/api/JobApplyAsync`, {
        headers: {
          Accept: 'application/json',
        },
        method: 'POST',
        body: formData,
      })
        .then(f => f.text())
        .then(b => {
          careerApplySuccessDiv.classList.remove('hide');
          careerApplyFormDiv.classList.add('hide');
          loading.classList.remove('hide');
        });
    } catch (ex) {
      console.log(ex);
      loading.classList.add('hide');
      errorBox.innerHTML = ex;
    }
  },
  jobApplyConsentChange: function (element) {
    document.querySelector('.js-consent-required').classList.remove('invalid');
  },
  filechange: function (element) {
    if (element.value != '') {
      var label = element.parentNode.querySelector('.js-file-input');
      document.querySelector('.js-file-label').classList.add('hide');
      label.innerHTML = element.files[0].name;
      element.parentNode.querySelector('label[for]').classList.add('hide');
      window.neptune.careers.attachFile();
    }
  },

  jobApplyInit: function () {
    this.jobAdvertInit();
  },
  jobListingInit: function () {
    fetch(window.neptune.getAzureFunctionEnv() + '/api/JobListGetAsync')
      .then(e => e.json())
      .then(r => {
        var listingItems = [];

        // we first go through departments to get a list of all careers
        r.Departments.forEach(g => {
          var jobsByDept = r.Careers.filter(
            h => h.Department.Name.toUpperCase() == g.Name.toUpperCase(),
          );

          var i = 0;
          // only show the title for the first item in the list.
          jobsByDept.forEach(r => {
            console.log(r);
            try {
              careers.innerHTML += `
                <div id="${r.BroadbeanId}" class="career-listing__item js-career-listing-item" data-type="${r.Type.Name}" data-location="${r.Location.Name}" data-department="${r.Department.Name}">
                    <h5 class="career-listing__heading"> ${i == 0 ? r.Department.Name : ''}</h5>
                    <div class="career-listing__item-row">
                        <div class="career-listing__career-type career-listing__cell"></div>
                        <div class="career-listing__career-name career-listing__cell">
                            <a href="${r.Handle}">${r.Name}</a>
                        </div>
                        <div class="career-listing__career-type career-listing__cell">
                            ${r.Type.Name}
                        </div>
                        <div class="career-listing__career-location career-listing__cell">
                            ${r.Location.Name}
                        </div>
                    </div>
                </div>
            `;
            } catch (e) {
              console.log(e, r);
            }
            i++;
          });
        });

        if (r.Departments != null && r.Departments.length > 0) {
          r.Departments.forEach(v => {
            depts.innerHTML += `<option>${v.Name}</option>`;
          });
        }

        if (r.Types != null && r.Types.length > 0) {
          r.Types.forEach(v => {
            types.innerHTML += `<option>${v.Name}</option>`;
          });
        }

        if (r.Locations != null && r.Locations.length > 0) {
          r.Locations.forEach(v => {
            locations.innerHTML += `<option>${v.Name}</option>`;
          });
        }
      });
  },
};
